export default __webpack_public_path__ + "static/media/roboto-slab-700.934d56e4.woff2";